module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/premier_desktop-fc70409c43660c3506e68beb79ed9786.webp";